// extracted by mini-css-extract-plugin
export default {"burger-menu":"Zbvyj"};